import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageServerError, MessageRefreshPage } from '@core/constants/messages';
import { SERVER_ERRORS } from '@mynexus/mynexus-ui-lib';
import { MessageService } from 'primeng/api';
import { Observable, throwError } from 'rxjs';
import { isDuplicatedAssignReferralError } from './http-specific-errors';

/** Type of the handleError function returned by HttpErrorHandler.createHandleError */
export type HandleError = 
  <T>(operation?: string, result?: T) => (error: HttpErrorResponse) => Observable<T>;

/** Handles HttpClient errors */
@Injectable()
export class HttpErrorHandler {
  constructor(private readonly messageService: MessageService) {}

  /** Create curried handleError function that already knows the service name */
  createHandleError = (serviceName = '') => <T>
    (operation = 'operation', result = {} as T) => this.handleError(serviceName, operation, result)

  /**
   * Returns a function that handles Http operation failures.
   * This error handler lets the app continue to run as if no error occurred.
   * @param serviceName = name of the data service that attempted the operation
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  // eslint-disable-next-line unused-imports/no-unused-vars
  handleError<T>(serviceName = '', operation = 'operation', result = {} as T) {
    // tslint:disable-next-line: no-any
    return (error: HttpErrorResponse): Observable<any> => {
      const reasonId = error.error?.reasonId;
      if (reasonId === 'not_found') {
        this.messageService.add({
          key: 'httpAction',
          severity: 'warn',
          summary: 'Warning',
          detail: MessageRefreshPage,
          life: 5000
        });
      } else if (isDuplicatedAssignReferralError(error)) {
        this.messageService.add({
          key: 'httpAction',
          severity: 'warn',
          summary: 'Warning',
          detail: error.error.errorData.message,
          life: 5000
        });
      } else if (SERVER_ERRORS.indexOf(reasonId) !== -1 && reasonId !== 'forbidden') {
        this.messageService.add({
          key: 'httpAction',
          severity: 'error',
          summary: 'Error',
          detail: MessageServerError,
          life: 5000
        });
      }
      return throwError(error);
    };
  }
}
